let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fBBK4")).then(() => parcelRequire('7uxuk'));